import axios from 'axios'
import cookie from './cookie.js';

let headerUrl = '/api';
import {Toast} from 'vant';
import jsBridge from '@/utils/jsBridge'

// 创建axios实例
const service = axios.create({
    timeout: 60000                 // 请求超时时间
});


// 获取设备类型
let deviceType = navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) ? 'iOS' : 'android'

// 获取app类型
let appType = jsBridge.callBackHandler('getAppType')


// request拦截器
service.interceptors.request.use(config => {
    // 获取凭证
    let ctlToken = cookie.get('ctl-token');

    // 获取教练端凭证
    let coachToken = localStorage.getItem('access-token');

    // 获取appid
    let appid = localStorage.getItem('appId');

    // 获取车型分类
    let ctlCarCategory = jsBridge.callBackHandler('getCarType')

    //定义全局头部Url
    config.url = headerUrl + config.url;

    // 定义headers
    config.headers['X-Requested-With'] = 'XMLHttpRequest';

    // 定义token
    ctlToken && (config.headers['ctl-token'] = ctlToken)

    // 定义appid
    appid && (config.headers['appid'] = appid)
    appid && (config.headers['ctl-appid'] = appid)

    // 定义教练端token
    if (coachToken) {
        config.headers['access-token'] = coachToken
        config.headers['coach-token'] = coachToken
    }

    // 定义app类型
    appType && (config.headers['app-type'] = appType)

    // 定义app车型分类
    ctlCarCategory && (config.headers['ctl-car-category'] = ctlCarCategory)

    // 定义设备类型
    config.headers['device-type'] = deviceType

    return config
}, error => {

    // 错误抛出Message
    Toast('加载超时');
    return Promise.reject(error)
});

// respone拦截器
service.interceptors.response.use(
    response => {
        if (response.data.code === '-1') {
            // 兼容教练端-1状态码
            if(jsBridge.hasNativeMethod('coachTimingTokenExpire')){
                jsBridge.callBackHandler('coachTimingTokenExpire')
            } else {
                setTimeout(()=>{
                    Toast(response.data.message);
                })
                setTimeout(() => {
                    jsBridge.callBackHandler('returnLastPage')
                    jsBridge.callBackHandler('loginUser')
                }, 1000)
            }
            return null
        } else if (response.data.code === '401') {
            setTimeout(()=>{
                Toast('请登录');
            })
            setTimeout(() => {
                jsBridge.callBackHandler('returnLastPage')
                jsBridge.callBackHandler('loginUser')
            }, 1000)
            return null
        }

        return response.data
    },
    error => {
        // 错误判断
        if (error && error.response) {
            switch (error.response.status) {
                case 400:
                    error.message = '请求错误';
                    break;

                case 401:
                    error.message = '请登录';
                    break;

                case 403:
                    error.message = '拒绝访问';
                    break;

                case 404:
                    error.message = `请求地址出错: ${error.response.config.url}`;
                    break;

                case 408:
                    error.message = '请求超时';
                    break;

                case 500:
                    error.message = '服务器内部错误';
                    break;

                case 501:
                    error.message = '服务未实现';
                    break;

                case 502:
                    error.message = '网关错误';
                    break;

                case 503:
                    error.message = '服务不可用';
                    break;

                case 504:
                    error.message = '网关超时';
                    break;

                case 505:
                    error.message = 'HTTP版本不受支持';
                    break;

                default:
            }
        }
        // 错误抛出Message
        Toast(error.message);
        return Promise.reject(error)
    }
);
export default service;
